













import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MpCard from '@/components/controls/mp-card/MpCard.vue';
import MpVideoStatistic from '@/components/wrappers/bundle/statistics/MpVideoStatistic.vue';
import { VideoStatistic } from '@/connectors/bundles/video-statistic.model';
import { Bundle } from '@/connectors/bundles/bundle.model';
@Component({
  components: { MpVideoStatistic, MpCard }
})
export default class MpBundleVideoStatistics extends Vue {
  @Prop({ required: true })
  videoStatistics!: VideoStatistic[];

  @Prop({ required: true })
  fixedCardHeight!: number;

  @Prop({ required: true })
  bundle!: Bundle;
}
